import { render, staticRenderFns } from "./earth-center.vue?vue&type=template&id=6dc2b712&scoped=true&"
import script from "./earth-center.vue?vue&type=script&lang=js&"
export * from "./earth-center.vue?vue&type=script&lang=js&"
import style0 from "./earth-center.vue?vue&type=style&index=0&id=6dc2b712&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc2b712",
  null
  
)

export default component.exports